import { Component, inject, Input, OnInit } from '@angular/core';
import { VeterinaryStationModel, VeterinaryStationService } from '@railmybox/api-booking';
import { Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AbstractValueAccessorComponent, ValueAccessorUtil } from '@railmybox/shared/util';

@UntilDestroy()
@Component({
  selector: 'rmb-veterinary-station-select',
  templateUrl: './veterinary-station-select.component.html',
  styleUrls: ['./veterinary-station-select.component.scss'],
  providers: [...ValueAccessorUtil.getValueAccessorProvider(VeterinaryStationSelectComponent)],
  standalone: false,
})
export class VeterinaryStationSelectComponent extends AbstractValueAccessorComponent<string> implements OnInit {
  private veterinaryStationService = inject(VeterinaryStationService);

  veterinaryStations$: Observable<VeterinaryStationModel[]>;
  selectedName: string;
  @Input() clearable = false;

  ngOnInit(): void {
    this.veterinaryStations$ = this.veterinaryStationService.listVeterinaryStations({ query: '' }).pipe(untilDestroyed(this));
  }

  onSelect(vetStation: VeterinaryStationModel): void {
    this.selectedName = vetStation?.name;
    this.value = vetStation?.id;
    this.onChange(vetStation?.id);
    this.changed.emit(vetStation?.id);
  }

  markInputAsTouched(): void {
    this.onTouched();
    this.blurred.emit();
  }

  async writeValue(value: string): Promise<void> {
    super.writeValue(value);

    if (!value) {
      return;
    }

    const veterinaryOffice = await this.veterinaryStationService
      .listVeterinaryStations({ query: value })
      .toPromise()
      .then((filteredValues) => filteredValues.find((vetStation) => vetStation.id === value));

    if (!veterinaryOffice) {
      return;
    }

    this.value = veterinaryOffice.id;
    this.selectedName = veterinaryOffice.name;
  }
}
